import './share.scss'
import React, {useEffect} from "react";
import {CircleIcon} from "../ui/circle-icon.js";
import FacebookIcon from '../../assets/Share-facebook.svg'
import LinkedInIcon from '../../assets/Share-linkedinsvg.svg'
import TwitterIcon from '../../assets/Share-twitter.svg'
import CopyIcon from '../../assets/Copy.svg'
import LinkIcon from '../../assets/link.svg'
import CloseIcon from '../../assets/close_S.svg'
import {Input} from "antd";
import 'antd/lib/input/style/index.css'
import {Analytics} from '../../helpers/analytics';

const Share = function (props) {

    useEffect(() => {
        const handleClickOutside = (e) => {
            const container = document.getElementById('share-popup');
            const button = document.getElementById('info-button');

            if(container && !container.contains(e.target) && button && !button.contains(e.target)) {
                // if the toggle is clicked, it will also trigger that event (which opens the menu again)
                // unless we stop propagation.
                e.stopPropagation();
                props.onClose()
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        }
    }, [props]);


    const copyLink = () => {
        let input = document.getElementById('url')

        if(input) {
            /* Select the text field */
            input.select();
            input.setSelectionRange(0, 99999); /*For mobile devices*/

            /* Copy the text inside the text field */
            document.execCommand("copy");
        }

    }

    const onShare = (platform) => {
        Analytics.trackEvent({
            action: 'share',
            category: 'platform',
            label: platform
        });
    }

    return <div className={'share-popup-container'}>
        <div className={'share-popup'}>
            <div id={'share-popup'}>
                <h3 style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    Share to social network
                    <img alt={'close_icon'}
                            src={CloseIcon}
                            onClick={props.onClose}
                            style={{cursor: 'pointer', outline: 'none'}}/>
                </h3>
                <Input id={'url'}
                        value={window.location.href}
                        prefix={
                            <img src={LinkIcon} alt={'link_icon'}/>
                        }
                        addonAfter={
                            <img onClick={copyLink} src={CopyIcon} alt={'copy_icon'} style={{fontSize: 0}}/>
                        }/>

                <div style={{display: 'flex', justifyContent: 'center', margin: '10px 0'}}>
                    <a target={'_blank'}
                            onClick={() => onShare('twitter')}
                            rel="noopener noreferrer"
                            href={`http://twitter.com/share?url=${window.location.href}`}>
                        <CircleIcon src={TwitterIcon} alt={'twitter_icon'} style={{margin: '0 10px'}}/>
                    </a>
                    <a target={'_blank'}
                            onClick={() => onShare('facebook')}
                            rel="noopener noreferrer"
                            href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}>
                        <CircleIcon src={FacebookIcon} alt={'facebook_icon'} style={{margin: '0 10px'}}/>
                    </a>
                    <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
                            rel="noopener noreferrer"
                            onClick={() => onShare('linkedin')}
                            target={'_blank'}>
                        <CircleIcon src={LinkedInIcon} alt={'linkedin_icon'} style={{margin: '0 10px'}}/>
                    </a>
                </div>
            </div>
        </div>
    </div>
}

export {Share}